import React, { useState, useEffect } from "react";
import "../css/HeroImage.css";

interface HeroButton {
  title?: string
  linkUrl?: string
  openInNewTab?: boolean
}

interface HeroProps {
  hero?: {
    eyebrow?: string
    headline?: string
    subheadline?: string
    buttons?: HeroButton[]
  }
}

const images = [
  "/images/slide_1.jpeg",
  "/images/slide_2.jpeg",
  "/images/slide_3.jpeg",
  "/images/slide_11.jpeg",
  "/images/food_slide.jpeg",
] as const;

export default function HeroImage({ hero }: HeroProps) {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  const headline = hero?.headline || "Maynooth's favourite neighbourhood spot."
  const subheadline =
    hero?.subheadline ||
    "Maynooth's home for coffee & pastries, breakfast, lunch & brunch, wine store, wine bar & neighbourhood dining spot."

  const defaultButton = {
    title: "Book now",
    linkUrl:
      "https://www.opentable.ie/booking/restref/availability?lang=en-IE&correlationId=8a580344-0250-4f19-9529-46622d12da90&restRef=176043&otSource=Restaurant%20website",
    openInNewTab: true,
  }

  return (
    <div className="hero-slideshow">
      {images.map((src, index) => (
        <img
          key={index}
          src={src}
          alt={`Slide ${index}`}
          className={`img-fluid slide ${index === currentIndex ? "active" : ""}`}
        />
      ))}

      <div className="hero-overlay">
        <div className="hero-text-box">
          {hero?.eyebrow ? <p className="text-uppercase text-white mb-2">{hero.eyebrow}</p> : null}
          <h1 style={{ color: "white" }}>{headline}</h1>
          <p>{subheadline}</p>
          <div className="d-flex flex-wrap justify-content-center gap-2 mt-2">
            {(hero?.buttons && hero.buttons.length > 0 ? hero.buttons : [defaultButton]).map((button, index) => (
              <a
                key={index}
                href={button.linkUrl || defaultButton.linkUrl}
                target={button.openInNewTab ? "_blank" : "_self"}
                rel={button.openInNewTab ? "noreferrer" : undefined}
                className="btn btn-light btn-outline-dark mt-2"
              >
                {button.title || defaultButton.title}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
